// import { useEffect, useState } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Carousel } from "react-bootstrap";
// import axios from "axios";
// import imege1 from './imeges/Lims.avif'
// import limis from './imeges/imege1.jpg'
import limis from './imeges/slide1image.jpg'
// import app   from './imeges/image2.3.jpeg'
import analytics from './imeges/imege3.jpg'
import slide2 from './imeges/slide2image.jpg'
import slide3 from './imeges/slide3image.jpg'
import slide4 from './imeges/slide4.1image.jpg'
// import slide5 from './imeges/slide5.1image.jpg'
import slide5 from './imeges/Hospital.jpeg'
import HealthCare from './imeges/healthcare.jpeg'
import { useRef, useState } from "react";
// import slide6 from './imeges/slide6image.jpg'




const CarouselPage = () => {
  const[interval,setinterval] = useState(3000);
  const carsouelRef = useRef();
  // const [images, setImages] = useState([]); // Store images
  // const [loading, setLoading] = useState(true); // Loading state
  // const [error, setError] = useState(null); // Error state

  // useEffect(() => {
  //   const fetchImages = async () => {
  //     try {
  //       const response = await axios.get("http://localhost:5000/api/img/images/carsouel"); // Fetch from backend
  //       setImages(response.data);
  //     } catch (error) {
  //       console.error("Error fetching images:", error);
  //       // setError("Failed to load images.");
  //     } 
  //   };

  //   fetchImages();
  // }, []);

  // 🔥 Fetch specific images by name 
  // const getImageUrl = (imageName,locaIamge) => {
  //   if (!images || images.length === 0) return locaIamge; // Return placeholder if not found
  //   const image = images.find((img) => img.original_name === imageName);
  //   return image ? image.url : null; // Default placeholder image
  // };

  // if (loading) return <p>Loading images...</p>;
  // if (error) return <p>{error}</p>;

  return (
    <div id="home"
    onClick={()=> setinterval(null)}
    onDoubleClick={()=>setinterval(3000)}
    >
     
      <Carousel  ref={carsouelRef}  interval={interval}  slide={false} pause={false}>
        {[
          { name: "limis", title: "Laboratory Information",image:limis, subtitle: "Management System", description: "Our LIMS solution is designed to automate, streamline &  effectively manage laboratory operations, data, and workflows. Centralized application helps to track samples, store results, dispatch patient results accurately every time & ensure compliance with regulatory standards." },

          { name: "app", title: " Practice Managment System", subtitle: "",image:slide2,  description: "Our PMS solution PRACTIease is a platform that helps manage the day-to-day aspects of scheduling, doctors availability, administrative & financial tasks,  It enables nurses to capture patient presenting complaints and ensures doctor has complete information about the patient before seeing him.  Our AI based algorithm suggests potential diagnostics test to treating doctors & coupled with Integrated Inventory, the solution enables better treatment outcome." },

          { name: "analytics", title: "Quality Control", subtitle: "",image:slide3, description: "Quality control (QC) in a laboratory setup is a critical process to ensure the accuracy, reliability, and reproducibility of test results. Our QC Module enables scheduling of QC runs, capture of critical sera attributes, capture of QC Run Data and enables our customers to calculate Laboratory Mean with 100 % accuracy.  Parameter wise data is historically stored for better assessment & LJ graphs are available at the click of a button for all tests.  Customers can opt to implement Westgard Rules on need basis to ensure 100 % automation & reliability" },

          { name: "limis", title: "Hospital Information System",image:slide4,  description: "Our comprehensive Hospital Information System is designed to manage all aspects of a hospital’s operations, integrating administrative, financial, and clinical functions into a single system. Being thee digital backbone of a healthcare facility, our system improves operational efficiency, enables to reduce cost and increase the revenue & also ensuring clinical accuracy.  Administrative Module in our HIS ensures zero revenue leakage and provides real time view of receivables.  Interoperability with external health systems/ insurers/Govt Authorities & data exchange with medical devices follows International protocols" },

          { name: "app", title: "Blood Bank & Integrated Inventory", subtitle: "",image:slide5,  description: "Our Blood Bank Module seamlessly work with Laboratory Information Management System or any 3rd party Hospital Information System.  It oversees the entire lifecycle of blood and blood products—from donor registration, patient screening, blood collection, blood testing, storage & retrieval, and distribution—ensuring safety, traceability, and compliance with regulatory standards.   Our Integrated Inventory gives a bird's eye view of the stock position of blood products and ensure the right quantity is available at the right place" },

            // { name: "analytics", title: "Custom Healthcare Solutions", subtitle: "",image:slide6,  description: "Project analytics is a systematic analysis of data to identify meaningful patterns and insights about an organization's projects." },
            { name: "analytics", title: "Health Analytics ", subtitle: "",image:analytics,  description: "Our Intuitive Health Analytics fetches data from any source using ETL tools and stores optimally in a centralized DB.  We build effective & intuitive dashboards that gives information on the past as well as on the future enabling decision makers to dissect the data & to take data based decision.  Care givers, Administrators, Clinicians, Senior Management & all stake holders can refer to our dashboard for decision making thereby helping effective utilization of resources/ effective patient outcomes" },
                      { name: "analytic", title: "", subtitle: "",image:HealthCare,  description: "Our Clinic Management System streamlines patient registration, appointment scheduling, and medical record management It enhances operational efficiency for clinics and hospitals with real-time tracking and secure data access.Designed for ease of use, it supports doctors, staff, and administrators in delivering better patient care." }

        ].map((slide, index) => (
          <Carousel.Item key={index}>
            <img
              className="d-block w-100"
              // src={getImageUrl(slide.name,slide.image)}
              src={slide.image}
              alt={slide.title}
              height={600}
                // objectFit={cover
              width={500}
              style={{ backgroundColor: "#343a40", objectFit:"cover" }}
            />
            {/* {slide.name  !== 'analytic' &&(
              <Carousel.Caption className="carousel-caption-custom">
              <h3>{slide.title} {slide.subtitle}</h3>
              <p className="d-none d-sm-block">{slide.description}</p>
              <p className="d-block d-sm-none small-description">{slide.description}</p>
            </Carousel.Caption>
            )} */}
               <Carousel.Caption className="carousel-caption-custom">
              <h3>{slide.title} {slide.subtitle}</h3>
              <p className="d-none d-sm-block">{slide.description}</p>
              <p className="d-block d-sm-none small-description">{slide.description}</p>
            </Carousel.Caption>

          </Carousel.Item>
        ))}
      </Carousel>
    </div>
    
  );
};

export default CarouselPage;
